'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  venues: {
    empty: 'Aucun lieu.',
    new: 'Ajouter un lieu',
    title: 'Lieux',
    addVenue: 'Ajouter un lieu',
    next: 'Page suivante',
    previous: 'Page précédente',
    sortDirection: {
      asc: 'en ordre croissant',
      desc: 'en ordre décroissant'
    },
    sortOrder: {
      name: 'nom',
      creation: 'date de création',
      modification: 'date de modification',
      created_at: 'date de création',
      updated_at: 'date de modification'
    },
    form: {
      address2: 'Adresse (2e ligne)',
      address: 'Adresse',
      businessHours: "Heures d'ouverture",
      cc_id: 'ID Culture Creates',
      city: 'Ville',
      confirmSave: 'Voulez-vous enregistrer les modifications \xE0 ce lieu\xA0?',
      country: 'Pays',
      dontSave: 'Ne pas enregistrer',
      eb_id: 'ID Eventbrite',
      latitude: 'Latitude',
      lockLatLon: 'Spécifier des valeurs lat. / long.',
      longitude: 'Longitude',
      name: 'Nom du lieu',
      otherNames: {
        label: 'Autres noms',
        placeholder: 'Un par ligne'
      },
      phone: 'Téléphone',
      postalCode: 'Code postal',
      save: 'Enregistrer',
      state: 'Province',
      website: 'Site web'
    },
    total: '%{smart_count} lieu classé par |||| %{smart_count} lieux classés par'
  },
  events: { // FIXME: should probably refactor this
    groupsBox: {
      add: 'Ajoutez des organisations',
      groupAlreadyExists: 'L’organisation existe déjà',
      help: 'Tapez quelques lettres pour commencer à chercher',
      noResults: 'Aucun résultat.',
      title: 'Organisations propriétaires',
      typeSome: 'Tapez pour lancer la recherche...'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/venues.js
// module id = 2299
// module chunks = 0